import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FetchSequence } from '../../actions/sequence';
import MapBox from '../shared/mapbox/index';
import Spinner from '../shared/spinner';
import { history } from '../../components/app';
// import html2canvas from 'html2canvas';
import domtoimage from 'dom-to-image';



const queryString = require('query-string');
let qs = queryString.parse(window.location.search);

class Mapbox extends PureComponent {

  
  componentDidMount(){
    if(qs.guid === undefined) history.push('/404');
  }

  componentDidUpdate(prevProp, prevState){

     const {
       sequence,
       currency,
       currency:{iso_currency_code},
       FetchSequence,
     } = this.props;



    if(currency !== prevProp.currency){
      if(sequence.length === 0){
        FetchSequence(qs.guid, qs.style, qs.optionals, qs.city, iso_currency_code, qs.stops, null, qs.bundle, qs.custom);
      }
    }



    if(sequence !== prevProp.sequence){



      document.addEventListener('mapbox_loaded_event', () => {


        // 1. create canvas offscreen
        // 2. copy mapbox into new canvas via html2html2canvas
        // 3. Resize newly created canvas
        // 4. Save newly created canvas (base64, blobs)

        /*
        const html2canvasProps = {
          logging:false,
          windowWidth:1200,
          windowHeight:450,
          width:1200,
          height:450,
          scale:1,
          allowTaint:true
        }

         setTimeout(()=>{

          html2canvas(document.querySelector("#capture"), html2canvasProps).then(canvas => {

              const img = new Image();
              img.src = canvas.toDataURL();
              img.onload = () => {

                const _canvas = document.createElement('canvas');
                const _ctx = _canvas.getContext('2d');

                _canvas.width = 1200;
                _canvas.height = 450;

                _ctx.drawImage(img, 0, 0, 1200, 450);

                // FOR DEBUGGING
                // document.body.appendChild(_canvas)

                //POST THIS
                console.log('BASE64 string to save', _canvas.toDataURL('image/jpeg', 0.9))
              }
            });

          }, 5000);
          */


        setTimeout(()=>{

          const options = {
            quality: 0.9,
            height:document.querySelector("#capture").offsetHeight,
            width:document.querySelector("#capture").offsetWidth
          }

          domtoimage.toJpeg(document.querySelector("#capture"), options)
          .then(function (dataUrl) {
            // console.log('BASE64 string to save', dataUrl)
            document.querySelector('.mapbox-textarea').value = dataUrl;

            //Save image
            // var img = new Image();
            // img.src = dataUrl;
            // document.body.appendChild(img);

          });
        }, 1000);

      });//end of mapload event


    }

  }

  render(){
    if(Object.keys(this.props.sequence).length === 0){
      return <Spinner text="Loading itinerary..." loadClass="orange-spinner-wrapper"/>
    }else{
      const { sequence:{data:{sequence}} } = this.props;
      const _sequence = (this.props.sequence && sequence !== undefined) ? sequence : "";

      return (
        <div className="row">
          <div className="small-12 column no-padding">
            <div className="itinerary-map-wrapper" id="capture">
              <MapBox countriesShow={_sequence} clickable={false} snapshotMode={"true"} id={"snapshotView"}  />
            </div>
          </div>
          <div className="small-12 column no-padding">
            <textarea className="mapbox-textarea" rows="3" cols="20"></textarea>
          </div>
        </div>
      )
    }
  }

}


function mapStateToProps(state){
  return {
    sequence:state.sequence.data,
    currency:state.currency
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchSequence
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Mapbox);



// WEBPACK FOOTER //
// ./src/components/mapbox/index.js